module.exports = __webpack_public_path__ + "static/media/galerija_2014 (41).299d3062.jpg";